import { Box, Button, Divider } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import RefreshIcon from '@mui/icons-material/Refresh';
import ImageIcon from '@mui/icons-material/Image';
import EditIcon from '@mui/icons-material/Edit';
import {
  PyrenzMenuContainer,
  PyrenzMenuButton,
  PyrenzMenuDivider,
} from '@client/theme';

interface MessageContextMenuProps {
  msg: {
    id?: number;
    text?: string;
    type?: 'user' | 'char';
    error?: boolean;
  };
  onRegenerate: (messageId: number) => void;
  onRemove: (messageId: number) => void;
  handleSpeak: (text: string) => void;
  handleCopy: (text: string) => void;
  onGenerateImage: (messageId: number) => void;
  onEditClick: (
    messageId: number,
    currentMessage: string,
    type: 'user' | 'char'
  ) => void;
  onClose: () => void;
}

const menuConfig = {
  user: [
    {
      icon: <EditIcon />,
      label: 'Edit',
      action: (props: MessageContextMenuProps) => () =>
        props.msg.id &&
        props.onEditClick(props.msg.id, props.msg.text || '', 'user'),
    },
    {
      icon: <FileCopyIcon />,
      label: 'Copy',
      action: (props: MessageContextMenuProps) => () =>
        props.handleCopy(props.msg.text || ''),
    },
    { divider: true },
    {
      icon: <DeleteIcon />,
      label: 'Delete',
      action: (props: MessageContextMenuProps) => () =>
        props.msg.id && props.onRemove(props.msg.id),
    },
  ],
  char: [
    {
      icon: <EditIcon />,
      label: 'Edit',
      action: (props: MessageContextMenuProps) => () =>
        props.msg.id &&
        props.onEditClick(props.msg.id, props.msg.text || '', 'char'),
    },
    {
      icon: <RefreshIcon />,
      label: 'Regenerate',
      action: (props: MessageContextMenuProps) => () =>
        props.msg.id && props.onRegenerate(props.msg.id),
    },
    { divider: true },
    {
      icon: <VolumeUpIcon />,
      label: 'Speak',
      action: (props: MessageContextMenuProps) => () =>
        props.handleSpeak(props.msg.text || ''),
    },
    {
      icon: <FileCopyIcon />,
      label: 'Copy',
      action: (props: MessageContextMenuProps) => () =>
        props.handleCopy(props.msg.text || ''),
    },
    {
      icon: <ImageIcon />,
      label: 'Generate Image',
      action: (props: MessageContextMenuProps) => () =>
        props.msg.id && props.onGenerateImage(props.msg.id),
    },
    { divider: true },
    {
      icon: <DeleteIcon />,
      label: 'Delete',
      action: (props: MessageContextMenuProps) => () =>
        props.msg.id && props.onRemove(props.msg.id),
    },
  ],
};

export const MessageContextMenu = (props: MessageContextMenuProps) => {
  const { msg, onClose } = props;
  if (msg.error) return null;

  const handleAction = (action: () => void) => {
    action();
    onClose();
  };
  const menuItems = menuConfig[msg.type || 'user'] || [];

  return (
    <PyrenzMenuContainer>
      {menuItems.map((item, index) =>
        item.divider ? (
          <PyrenzMenuDivider key={index} />
        ) : (
          <PyrenzMenuButton
            key={index}
            onClick={() => handleAction(item.action(props))}
            startIcon={item.icon}
          >
            {item.label}
          </PyrenzMenuButton>
        )
      )}
    </PyrenzMenuContainer>
  );
};
